import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api.js';
import { setAuth, isLoggedIn } from '../auth.js';

export default function Login() {
  const btnRef = useRef(null);
  const nav = useNavigate();
  const [error, setError] = useState('');
  const [clientId, setClientId] = useState(null);

  useEffect(() => {
    if (isLoggedIn()) { nav('/', { replace: true }); return; }
    api.get('/api/auth/config').then(c => setClientId(c.google_oauth_client_id)).catch(e => setError(e.message));
  }, [nav]);

  useEffect(() => {
    if (!clientId || !btnRef.current) return;
    let cancelled = false;
    const renderWhenReady = () => {
      if (cancelled) return;
      if (!window.google?.accounts?.id) {
        setTimeout(renderWhenReady, 100);
        return;
      }
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: async (resp) => {
          try {
            const { token, user } = await api.post('/api/auth/google', { credential: resp.credential });
            setAuth(token, user);
            nav('/', { replace: true });
          } catch (e) {
            setError(e.message || 'Sign-in failed');
          }
        },
      });
      window.google.accounts.id.renderButton(btnRef.current, {
        type: 'standard', theme: 'filled_blue', size: 'large', text: 'signin_with', shape: 'rectangular',
      });
    };
    renderWhenReady();
    return () => { cancelled = true; };
  }, [clientId, nav]);

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-gradient-to-br from-slate-50 via-white to-brand-50">
      <div className="w-full max-w-sm card p-8 text-center">
        <img src="/iaapi-logo.png" alt="IAAPI" className="h-12 w-auto mx-auto" />
        <div className="mt-2 text-xs uppercase tracking-wider text-slate-400">Campaigns Admin</div>
        <div className="mt-1 text-sm text-slate-500">Indian Association of Amusement Parks &amp; Industries</div>

        <div className="mt-8">
          {!clientId && !error && <div className="text-sm text-slate-400">Loading…</div>}
          {clientId && <div ref={btnRef} className="flex justify-center" />}
          {error && <div className="mt-3 text-sm text-rose-600">{error}</div>}
        </div>

        <div className="mt-8 text-[11px] text-slate-400 leading-relaxed">
          Sign in with the Google account on the IAAPI admin allow-list.
          <br/>Need access? Ask an existing admin.
        </div>
      </div>
    </div>
  );
}
